import { FC } from "react";

import { Box, Stack, SxProps, Theme } from "@mui/material";

import { mergeSx } from "@/common/helpers/mergeSx";

type FormV2Step2LayoutProps = {
  isEmbed?: boolean;
  buyerInformationPosition: "before-summary" | "after-payment" | null;
  slots: {
    backButton: React.ReactNode;
    peerCredibilityMessage?: React.ReactNode;
    buyerInformation: React.ReactNode;
    shippingSection?: React.ReactNode;
    buyerQuestions?: React.ReactNode;
    fulfillmentSection?: React.ReactNode;
    summarySection: React.ReactNode;
    paymentSection: React.ReactNode;
    submitButton: React.ReactNode;
    userAgreement?: React.ReactNode;
    zeffyLogo?: React.ReactNode;
  };
  sx?: SxProps<Theme>;
};

export const FormV2Step2Layout: FC<FormV2Step2LayoutProps> = ({ buyerInformationPosition, isEmbed, slots, sx }) => {
  return (
    <Stack
      gap={3}
      alignItems="flex-start"
      sx={mergeSx(
        {
          maxWidth: "800px",
          marginInline: "auto",
          padding: { xs: 3, sm: isEmbed ? 5 : 3, md: 5 },
          paddingTop: { xs: 2, sm: isEmbed ? 5 : 2, md: 5 },
        },
        sx
      )}
      data-test="ticketing-container-step2"
    >
      {slots.backButton}
      {!!slots.peerCredibilityMessage && slots.peerCredibilityMessage}
      <Stack width="100%" gap={5} sx={{ zIndex: 2 }}>
        {buyerInformationPosition === "before-summary" && slots.buyerInformation}
        {slots.buyerQuestions}
        {slots.fulfillmentSection}
        {slots.summarySection}
        {slots.paymentSection}
        {buyerInformationPosition === "after-payment" && slots.buyerInformation}
        {slots.shippingSection}
        <Stack gap={2}>
          {slots.submitButton}
          {slots.userAgreement}
        </Stack>
      </Stack>
      {!isEmbed && slots.zeffyLogo && (
        <Box
          sx={{
            position: { md: "fixed" },
            bottom: { md: 24 },
            right: { md: 24 },
            display: { xs: "flex", md: "block" },
            justifyContent: { xs: "center", md: "unset" },
            paddingBlock: { xs: 2, md: 0 },
            zIndex: 1,
          }}
        >
          {slots.zeffyLogo}
        </Box>
      )}
    </Stack>
  );
};
